export const pkgName = 'vtbeco-search';
